export default "__VITE_PUBLIC_ASSET__af631389__"